import { useFormContext } from 'react-hook-form';
import useInputFocusLock from '../../../hooks/useInputFocusLock';
const useAutoInputRef = (name, isFocused) => {
    const { register } = useFormContext();
    const { onBlur, ref } = register(name);
    const inputRef = useInputFocusLock(isFocused);
    const mergedRef = (el) => {
        ref(el);
        inputRef.current = el;
    };
    return { ref: mergedRef, onBlur };
};
export default useAutoInputRef;
//# sourceMappingURL=useAutoInputRef.js.map